import { ModelSagres } from "../../model-sagres";

export class DadosComplementaresCrtLicOutraUg extends ModelSagres {
  NmUnidadeGestora: string;
  DeModalidade: string;
}
